import { render } from "./Page.vue?vue&type=template&id=7fda37ab&scoped=true"
const script = {}

import "./Page.vue?vue&type=style&index=0&id=7fda37ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fda37ab"]])

export default __exports__